import useProject from '@hooks/useProject';
import {
    APIProvider, Map, MapCameraChangedEvent, Marker,
} from '@vis.gl/react-google-maps';
import {
    useCallback, useState,
} from 'react';

import { MapProps } from '../types';
import ClusteredMarkers from './ClusteredMarker';
import LocationButton from './LocationButton';

function GoogleMap({
    center, zoom = 13, width = '100%', markers, onMarkerClick, height, onBoundChange,
    showMyLocation, myLocation,
}:MapProps) {
    const id = 'google-map';
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const handleBoundChanged = useCallback((e: MapCameraChangedEvent) => {
        if (isDragging) {
            return;
        }
        const {
            south, east, north, west,
        } = e.detail.bounds;
        const { lat, lng } = e.detail.center;
        const neLon = east;
        const neLat = north;
        const swLon = west;
        const swLat = south;
        onBoundChange?.({
            neLat, neLon, swLat, swLon, lat, lng,
        });
    }, [onBoundChange, isDragging]);
    const project = useProject();
    const mapApiKey = project?.mapApiKey;
    return (
        <div style={{
            width,
            height,
            minWidth: width,
            minHeight: height,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        }}>
            {mapApiKey && (
                <APIProvider apiKey={mapApiKey}>
                    <Map defaultCenter={center}
                        defaultZoom={zoom}
                        minZoom={7}
                        id={id}
                        mapId='DEMO_MAP_ID'
                        gestureHandling='greedy'
                        disableDefaultUI
                        onDragstart={() => setIsDragging(true)}
                        onDragend={() => setIsDragging(false)}
                        onBoundsChanged={handleBoundChanged}>
                        <ClusteredMarkers markers={markers}
                            onMarkerClick={onMarkerClick}/>
                        {showMyLocation && (
                            <Marker position={myLocation} title='내 위치' />
                        )}
                    </Map>
                    {showMyLocation && (
                        <LocationButton center={myLocation}/>
                    )}
                </APIProvider>
            )}
        </div>
    );
}

export default GoogleMap;
